module.exports = __webpack_public_path__ + "static/media/meta-image.8336e84c.png";